import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

type StyledPointsMiniBannerProps = {
  $accentColor?: string;
  $iconBackgroundColor?: string;
  $gradientStart?: string;
  $gradientEnd?: string;
};

const DEFAULT_ACCENT_COLOR = '#A4451D';

export const StyledPointsMiniBanner = styled.div<StyledPointsMiniBannerProps>`
  .points-mini-banner {
    width: 100%;
    min-height: ${toRem(76)};
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    border-radius: ${toRem(14)};
    background-color: ${baseVariables.color['base20']};
    box-shadow: 0 ${toRem(4)} ${toRem(10)} 0 rgba(0, 0, 0, 0.07);
    color: ${baseVariables.color['base10']};
    overflow: hidden;
    text-decoration: none;

    &:hover {
      color: ${baseVariables.color['base10']};
      text-decoration: none;
    }

    &:focus-visible {
      outline: ${toRem(2)} solid ${baseVariables.color['base10']};
      outline-offset: ${toRem(2)};
    }
  }

  button.points-mini-banner {
    width: 100%;
    padding: 0;
    text-align: left;
    border: none;
  }

  .points-mini-banner__tier-strip {
    width: ${toRem(6)};
    flex-shrink: 0;
    background: linear-gradient(
      180deg,
      ${props => props.$gradientStart || props.$accentColor || DEFAULT_ACCENT_COLOR} 0%,
      ${props => props.$gradientEnd || props.$accentColor || DEFAULT_ACCENT_COLOR} 100%
    );
  }

  .points-mini-banner__content {
    flex: 1 0 0;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
    padding: ${toRem(16)} ${toRem(8)} ${toRem(16)} ${toRem(16)};
    align-self: stretch;
  }

  .points-mini-banner__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${toRem(48)};
    height: ${toRem(48)};
    border-radius: ${toRem(8)};
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    background-color: ${props => props.$iconBackgroundColor || baseVariables.color['neutral10']};
    color: ${props => props.$accentColor || DEFAULT_ACCENT_COLOR};
  }

  .points-mini-banner__icon-glyph:before,
  .points-mini-banner__chevron-icon:before {
    font-size: ${toRem(24)};
  }

  .points-mini-banner__text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: ${toRem(4)};
  }

  .points-mini-banner__title {
    color: var(--Color-Set-brand-fg-color, #1c1c1c);
  }

  .points-mini-banner__description {
    color: var(--Color-Set-brand-alt-color, #707070);
  }

  .points-mini-banner__chevron {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${toRem(8)} 0 0;
    flex-shrink: 0;
  }
`;
